import { ComponentColors } from '@/enums'
import {
  componentColorToPrimaryColorMap,
  themeTransition,
  toThemePixels,
} from '@/utils'
import styled, { keyframes } from 'styled-components'
import { prop } from 'styled-tools'

interface ContainerProps {
  height?: string | number
  width?: string | number
  color?: keyof typeof ComponentColors
}

export const Container = styled.div<ContainerProps>`
  background-color: ${(props) => props.theme.color.b10};
  width: ${prop('width')};
  height: ${prop('height')};
  border-radius: 12px;
  background-color: ${(props) => props.theme.color.b10};
  outline: 1px solid ${(props) => props.theme.color.b30};
`

const progress = keyframes`
0% {
  width: 0;
}
`

export const InnerContainer = styled.div<ContainerProps>`
  width: ${prop('width')}%;
  height: ${prop('height')};
  border-radius: ${toThemePixels(1)};
  background-color: ${(props) =>
    props.theme.color[
      componentColorToPrimaryColorMap[props.color || ComponentColors.success]
    ]};
  transition: ${themeTransition('width')};

  animation: ${progress} 0.4s linear;
`
